import { Injectable, inject } from '@angular/core';
import { CourseService } from './course.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { SnackbarService } from '../../../../core/services/snackbar.service';
import { firstValueFrom } from 'rxjs';
import { CoursePreviewDialogComponent } from '../../learning-plan/components/course-preview-dialog/course-preview-dialog.component';
import { CustomPortalError } from '../../../../core/errors/models/CustomPortalError';
import { Store } from '@ngxs/store';
import { CurrentUserState } from '../../../../core/store/current-user/current-user.state';
import { DIALOG_SIZE_LARGE } from '../../../../shared/components/dialog/dialog-sizes';
import { AnalyticsService } from '../../../../core/services/analytics/analytics.service';

@Injectable({
  providedIn: 'root',
})
export class CoursePreviewService {
  dialog = inject(MatDialog);
  private readonly courseService = inject(CourseService);
  private readonly translocoService = inject(TranslocoService);
  private readonly snackbarService = inject(SnackbarService);
  private readonly store = inject(Store);
  private readonly analyticsService = inject(AnalyticsService);

  async open(courseId: string) {
    const lang = this.translocoService.getActiveLang();
    const subscriptionId = this.store.selectSnapshot(
      CurrentUserState.subscriptionId,
    );
    if (!subscriptionId) {
      return;
    }

    try {
      await firstValueFrom(this.courseService.initCoursePreview());
      const previewOpenedAt = performance.now();
      const dialogRef = this.dialog.open(CoursePreviewDialogComponent, {
        autoFocus: false,
        ...DIALOG_SIZE_LARGE,
        data: {
          courseId,
          lang,
          subscriptionId,
        },
      });
      dialogRef.afterClosed().subscribe(() => {
        this.analyticsService.track('course_preview_seen', {
          courseId,
          engagementDurationSeconds: Math.round(
            (performance.now() - previewOpenedAt) / 1000,
          ),
        });
      });
    } catch (error) {
      this.snackbarService.error((error as CustomPortalError).errorType);
    }
  }
}
